import { fade } from "@material-ui/core/styles/colorManipulator";

const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles(({ palette: { custom, primary } }) => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
  },
  moreButton: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: 32,
    height: 32,
    margin: "0 4px",
    background: "none",
    border: 0,
    borderRadius: 4,
    outline: 0,
    cursor: "pointer",
    "&::before": {
      content: "''",
      position: "absolute",
      top: -4,
      right: -4,
      bottom: -4,
      left: -4,
    },
    "&:hover": {
      background: fade(custom.low, 0.1),
    },
    "&:focus": {
      boxShadow: `0 0 4px ${primary.main}`,
    },
  },
  moreIcon: {},
  moreIcon_default: {
    fill: custom.grey[700],
  },
  moreIcon_primary: {
    fill: primary.main,
  },
  dropdown: {
    display: "flex",
    flexDirection: "column",
    background: custom.high,
    border: `1px solid ${custom.border[200]}`,
    boxShadow: `2px 2px 4px ${fade(custom.low, 0.2)}`,
  },
}));

export default useStyles;
